import { render, staticRenderFns } from "./Transferir.vue?vue&type=template&id=8a89a646&scoped=true&"
import script from "./Transferir.vue?vue&type=script&lang=js&"
export * from "./Transferir.vue?vue&type=script&lang=js&"
import style0 from "./Transferir.vue?vue&type=style&index=0&id=8a89a646&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a89a646",
  null
  
)

export default component.exports